import { useQuery } from 'react-query'

import { ExpenseMileageConfiguration } from '@webapp/modules/expense/entities'
import { expenseMileageConfigurationQueryConfig } from '@webapp/modules/expense/query-configs/expenseMileageConfiguration'

interface UseQueryExpenseMileageConfigurationParams {
  onError?: (err: unknown) => void
  enabled?: boolean
}

interface UseQueryExpenseMileageConfigurationReturn {
  configuration: Nullable<ExpenseMileageConfiguration>
  isFetching: boolean
  isLoading: boolean
}

export const useQueryExpenseMileageConfiguration = ({
  onError,
  enabled = true,
}: UseQueryExpenseMileageConfigurationParams = {}): UseQueryExpenseMileageConfigurationReturn => {
  const { data, isFetching, isLoading } = useQuery({
    ...expenseMileageConfigurationQueryConfig.get(),
    onError,
    enabled,
  })

  return {
    configuration: data?.data
      ? new ExpenseMileageConfiguration(data.data)
      : null,
    isFetching,
    isLoading,
  }
}
